import React, { useEffect, useState } from 'react';
import './index.scss';

const calculateTimeRemaining = endDate => {
  const difference = new Date(endDate).getTime() - Date.now();

  if (difference <= 0) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }

  const totalSeconds = Math.floor(difference / 1000);

  return {
    days: Math.floor(totalSeconds / (24 * 60 * 60)),

    hours: Math.floor((totalSeconds % (24 * 60 * 60)) / (60 * 60)),

    minutes: Math.floor((totalSeconds % (60 * 60)) / 60),

    seconds: totalSeconds % 60
  };
};

const CountdownTimer = ({ endDate, className = '' }) => {
  const [timeRemaining, setTimeRemaining] = useState(() =>
    calculateTimeRemaining(endDate)
  );

  useEffect(() => {
    const interval = window.setInterval(() => {
      setTimeRemaining(calculateTimeRemaining(endDate));
    }, 1000);

    return () => {
      window.clearInterval(interval);
    };
  }, [endDate]);

  const timeUnits = [
    {
      value: timeRemaining.days,
      label: 'DAYS'
    },
    {
      value: timeRemaining.hours,
      label: 'HRS'
    },
    {
      value: timeRemaining.minutes,
      label: 'MIN'
    },
    {
      value: timeRemaining.seconds,
      label: 'SEC'
    }
  ];

  return (
    <div className={`countdown ${className}`}>
      {timeUnits.map(unit => (
        <div className="countdown__item" key={unit.label}>
          <span className="countdown__value">
            {unit.value.toString().padStart(2, '0')}
          </span>

          <span className="countdown__label">{unit.label}</span>
        </div>
      ))}
    </div>
  );
};

export default CountdownTimer;
